import { render, staticRenderFns } from "./TournamentEditGridSettings.vue?vue&type=template&id=c2176a4c&scoped=true"
import script from "./TournamentEditGridSettings.vue?vue&type=script&lang=js"
export * from "./TournamentEditGridSettings.vue?vue&type=script&lang=js"
import style0 from "./TournamentEditGridSettings.vue?vue&type=style&index=0&id=c2176a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2176a4c",
  null
  
)

export default component.exports